import React from 'react';
import './style.scss';

export default function WelcomePage() {

  return (
    <React.Fragment>
      <div className={'section section-welcome'}>
        <div className={'section-heading'}>
          {/* <h4 className={'section-title'}>Welcome</h4> */}
        </div>
        <div className={'section-body'}>
          <h4>Welcome</h4>
          <p>“Whether you think you can, or you think you can’t – you’re right.” - Henry Ford</p>
          <img src="/assets/images/bg-welcome.png" alt="" />
        </div>
      </div>
    </React.Fragment>
)}
